export default "__VITE_ASSET__87nMgSwlW0cl4fQMqRROJQ__"